<template>
  <div class="window-wrap">
    <h1>{{data.num}}</h1>
    <h2>{{data.title}}</h2>
    <img v-if="flag" class="pic" :src="data.url">
    <div v-else class="pic-none"></div>
    <p class="con">{{data.con}}</p>
    <img class="arrow" src="../../../assets/img/part3-arrow.png">
  </div>
</template>

<script>
  export default {
    name: "window",
    props: ['data','flag']
  }
</script>

<style lang="less" scoped>
  .window-wrap {
    width: 95%;
    height: 100%;
    margin: auto;
    padding-top: 3%;
    position: relative;
    cursor: pointer;
    background: #ffffff;
    h1 {
      width: 71px;
      height: 44px;
      margin: auto;
      background: url("../../../assets/img/num-bg1.png");
      font-size: 2rem;
      text-align: center;
      line-height: 44px;
    }
    h2 {
      margin: 0% 0 1%;
      text-align: center;
      font-size: 1.4rem;
    }
    .pic {
      display: block;
      width: 70%;
      margin: 0 auto 2%;
    }
    .pic-none {
      display: block;
      width: 346px;
      height: 420px;
      margin: 0 auto 2%;
    }
    p {
      width: 90%;
      margin: 2% auto 0;
      text-align: left;
      font-size: 1rem;
    }
    .arrow {
      display: none;
      position: absolute;
      width: 25px;
      bottom: 30px;
      left: calc(~'50% - 12.5px');
    }
    &:hover {
      color: white;
      background: #0AD3FD;
    }
    &:hover h1 {
      background: url("../../../assets/img/num-bg2.png");
    }
    &:hover .arrow {
      display: block;
    }
  }
  @media screen and (max-width: 1536px){
    .window-wrap {
      .pic {
        width: 60%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/part3/window/Window.vue